<template>
  <div>
    <DetailSheetHeader title="Waypoint groups" show-back @back="backClicked" />

    <div class="p-3">
    <div v-for="waypointGroup in sortedWaypointGroups" :key="waypointGroup.obfuscatedId">
      <div class="d-flex justify-content-between align-items-center" role="button" @click="waypointGroupClicked(waypointGroup)">
        <div class="d-flex flex-column">
          <p class="mb-1">{{waypointGroup.title}} ({{waypointGroup.waypoints.length}})</p>

          <div class="d-flex align-items-center">
            <span role="button" class="text-muted d-flex align-items-center mr-3" @click.stop="exportWaypointGroupToGPX(waypointGroup)"> GPX <span class="material-icons ml-1" style="font-size: 17px;">download</span>
            </span>
            <span role="button" class="text-muted d-flex align-items-center" @click.stop="printWaypointGroup(waypointGroup)">
              Print <span class="material-icons ml-1" style="font-size: 17px;">print</span>
            </span>
          </div>
        </div>
        <span class="float-right d-flex justify-content-center">
          <span class="material-icons mr-2">chevron_right</span>
        </span>
      </div>
      <hr class="my-2">
    </div>
    </div>

  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { mapState } from 'vuex';
import { WaypointOptionsDialogPages } from '../../../utils/models/WaypointOptionsDialogPages';
import DetailSheetHeader from '../../../utils/shared_components/detail_sheet/DetailSheetHeader.vue';

export default defineComponent({
  components: { DetailSheetHeader },
  data() {
    return {
    };
  },
  mounted() {
    this.$store.dispatch('waypoints/getAllUserWaypointGroups');
  },
  methods: {
    backClicked() {
      this.$store.commit('waypoints/popPage');
    },
    waypointGroupClicked(waypointGroup) {
      this.$store.dispatch('waypoints/getWaypointGroup', waypointGroup.clientId);
      this.$store.commit('waypoints/setTopPage', WaypointOptionsDialogPages.WaypointGroupsWaypoints);
    },
    exportWaypointGroupToGPX(waypointGroup) {
      // Prevent the waypointGroupClicked method from firing when clicking export
      // (Handled by @click.stop in the template now)
      this.$store.dispatch('waypoints/exportWaypointGroupToGPX', waypointGroup);
    },
    printWaypointGroup(waypointGroup) {
      // Prevent the waypointGroupClicked method from firing when clicking export
      // (Handled by @click.stop in the template now)
      window.location.href = `/print-maps?data_ids[]=${waypointGroup.id}&data_types[]=WaypointGroup`;
    },
  },
  computed: {
    // Map the original state property
    ...mapState({
      allUserWaypointGroupsFromState: (state) => state.waypoints.allUserWaypointGroups,
    }),
    // Create a new computed property that sorts the groups
    sortedWaypointGroups() {
      // Return an empty array if the original data is not yet available or empty
      if (!this.allUserWaypointGroupsFromState || this.allUserWaypointGroupsFromState.length === 0) {
        return [];
      }
      // Create a shallow copy to avoid mutating the original Vuex state
      return [...this.allUserWaypointGroupsFromState].sort((a, b) => {
        // Use localeCompare for proper alphabetical sorting, case-insensitive
        return a.title.localeCompare(b.title, undefined, { sensitivity: 'base' });
      });
    }
  },
});
</script>

<style scoped>
/* Add some optional styling for better alignment if needed */
.d-flex.justify-content-between {
  align-items: center; /* Vertically align items */
}
</style>
